import { TransitionPainter, TransitionType } from '../types';
import { createFadePainter } from './fade';
import { createSlidePainter } from './slide';
import { createIrisPainter } from './iris';
import { createIrisHolePainter } from './irisHole';
import { createSlidingDoorPainter } from './slidingDoor';

const noopPainter: TransitionPainter = {
  setup() {},
  update() {},
  hide() {},
  dispose() {},
};

export function createPainter(type: TransitionType): TransitionPainter {
  switch (type) {
    case 'fade':          return createFadePainter();
    case 'slide':         return createSlidePainter();
    case 'iris':          return createIrisPainter();
    case 'iris-hole':     return createIrisHolePainter();
    case 'sliding-door':  return createSlidingDoorPainter();
    case 'none':          return noopPainter;
  }
}
